import React, { useEffect, useState } from "react";
import { Button, Table } from "antd";
import editIcon from "../../../Assets/Images/edit-icon.svg";
import deleteIcon from "../../../Assets/Images/delete-icon.svg";
import { FundraiserServices } from "../../../Services/API/fundraisersService";
import { useNavigate } from "react-router-dom";
import { idExtractor } from "../../../Utils/Split";
import { toast } from "react-toastify";
import Loader from "../../../Components/Loader/Loader";
import tableCellRender from "../../../Components/TableCellRender/tableCellRender";
import { sessionServices } from "../../../Utils/SessionServices";
import AlertModal from "../../../Components/AlertModal/AlertModal";
import { Gid } from "../../../Utils/constants";

export default function Fundraisers() {
  const navigate = useNavigate();
  const windowWidth = window.innerWidth;
  const [loader, setLoader] = useState(true);
  const [fundraisers, setFundraisers] = useState([]);
  const [role, setRole] = useState("");
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedFundraiser, setSelectedFundraiser] = useState("");

  useEffect(() => {
    getRole();
  }, []);

  useEffect(() => {
    getAllFundraisers();
  }, [role]);

  const getRole = () => {
    sessionServices
      .getSessionStorageItem("role")
      .then((res) => {
        setRole(res);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getAllFundraisers = () => {
    if (role) {
      FundraiserServices.getAllFundraisers(role)
        .then((res) => {
          setFundraisers(res?.data);
          setLoader(false);
        })
        .catch((err) => {
          setLoader(false);
          toast.error("Something went wrong, please try again later");
          console.log(err);
        });
    }
  };

  const deleteUser = (fundraiser) => {
    const id = fundraiser?.id;
    FundraiserServices?.deleteFundraiser(id)
      .then((res) => {
        toast.success("Deleted Successfully");
        setLoader(true);
        setTimeout(() => {
          getAllFundraisers();
        }, 3000);
      })
      .catch((err) => {
        toast.error("Something went wrong");
      });
  };

  const handleDelete = () => {
    deleteUser(selectedFundraiser);
    setShowDeleteModal(false);
  };

  const renderActionBtns = (type, value) => {
    switch (type) {
      case "editbtn":
        return (
          <div className="edit-fundraiser-container">
            <img
              className="actions-icons"
              src={editIcon}
              onClick={() =>
                navigate("/fundraisers", {
                  state: { action: "edit", data: value },
                })
              }
              alt="Edit Fundraiser"
            />
          </div>
        );
      case "deletebtn":
        return (
          <div className="delete-fundraiser-container">
            <img
              onClick={() => {
                setSelectedFundraiser(value);
                setShowDeleteModal(true);
              }}
              className="actions-icons"
              src={deleteIcon}
              alt="Delete Fundraiser"
            />
          </div>
        );
      default:
        break;
    }
  };

  const columns = [
    {
      title: "Fundraiser Details",
      dataIndex: "title",
      key: "title",
      fixed: "left",
      sorter: (a, b) => a.title.localeCompare(b.title),
      render: (value, row) => {
        const handleNavigate = () => {
          let temp = idExtractor(row?.id, "/");
          navigate(`/fundraiser/${temp[temp?.length - 1]}`);
        };
        return (
          <div onClick={() => handleNavigate()}>
            {tableCellRender(row, "fund-dtls")}
          </div>
        );
      },
    },
    {
      title: "Duration",
      dataIndex: "start_date",
      key: "start_date",
      width: 180,
      render: (value, row) => {
        return tableCellRender(row, "date-val");
      },
    },
    {
      title: "GSA",
      dataIndex: "gsa_string",
      key: "gsa_string",
      sorter: (a, b) => a?.gsa_string?.localeCompare(b.gsa_string),
      render: (value) => {
        const gsaString = idExtractor(value, "|")[0] || "";
        return tableCellRender(gsaString, "single-val");
      },
    },
    {
      title: "Fundraiser Hero",
      dataIndex: "fundraiser_hero_string",
      key: "fundraiser_hero_string",
      sorter: (a, b) =>
        a?.fundraiser_hero_string?.localeCompare(b?.fundraiser_hero_string),
      render: (value) => {
        const fundraiserHero = idExtractor(value, "|")[0] || "";
        return tableCellRender(fundraiserHero, "single-val");
      },
    },
    {
      title: "Goal",
      dataIndex: "goal",
      key: "goal",
      width: 150,
      sorter: {
        compare: (a, b) => a.goal - b.goal,
      },
      render: (value) => {
        return tableCellRender(value, "amount");
      },
    },
    {
      title: "Funds Raised",
      dataIndex: "total_raised",
      key: "total_raised",
      width: 150,
      sorter: {
        compare: (a, b) => a.total_raised - b.total_raised,
      },
      render: (value) => {
        return tableCellRender(value, "amount");
      },
    },
    {
      title: " ",
      dataIndex: "",
      key: "",
      width: 120,
      render: (value, row) => {
        return (
          <div className="actions-div">
            <>
              {row?.campaign_status !== "COMPLETED" &&
                renderActionBtns("editbtn", value)}
              {role !== "HERO" &&
                row?.campaign_status === "UPCOMING" &&
                renderActionBtns("deletebtn", value)}
            </>
          </div>
        );
      },
    },
  ];

    if (loader) {
        return <Loader />;
    } else {
        return (
            <>
                <div className="listing-page">
                    <div className="listing-header-container">
                        <div className="heading">Fundraisers List</div>
                        {role !== "HERO" ? (
                            <div className="add-btn-container">
                                <Button
                                    className="add-btn"
                                    onClick={() =>
                                        navigate("/fundraisers", {
                                            state: { action: "add", data: "" },
                                        })
                                    }
                                >
                                    Add New Fundraiser
                                </Button>
                            </div>
                        ) : (
                            <></>
                        )}
                    </div>
                    {fundraisers?.length > 0 ? (
                        <div className="table-container">
                            <Table
                                className="table-class"
                                columns={columns}
                                dataSource={fundraisers}
                                scroll={{
                                    x: "auto",
                                }}
                            />
                        </div>
                    ) : (
                        <div className="no-data">No data</div>
                    )}
                </div>
                {showDeleteModal && (
                    <AlertModal
                        openModal={showDeleteModal}
                        closeModal={() => setShowDeleteModal(false)}
                        handleYes={() => handleDelete()}
                        title={"fundraiser"}
                    />
                )}
            </>
        );
    }
}
